<div class="grid-section">
  <div class="toolbar">
    <dx-button
      icon="plus"
      text="Dodaj novi"
      type="default"
      (onClick)="onAddClick()">
    </dx-button>
    
    <dx-button
      icon="edit"
      text="Izmijeni"
      type="default"
      [disabled]="!selectedArtikl"
      (onClick)="onEditClick()">
    </dx-button>
    
    <!-- <dx-button
      icon="trash"
      text="Delete"
      type="danger"
      [disabled]="!selectedArtikl"
      (onClick)="onDeleteClick()">
    </dx-button> -->
    
    <dx-button
      icon="refresh"
      text="Osvježi"
      type="default"
      (onClick)="loadArtikli()">
    </dx-button>
  </div>

  <dx-data-grid
    #artikliGrid
    id="artikliGrid"
    keyExpr="id"
    [dataSource]="gridData"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
      showPageSizeSelector: true,
      allowedPageSizes: [10, 20, 50, 100],
      showInfo: true
    }"
    [selection]="{ mode: 'single' }"
    [rowAlternationEnabled]="true"
    (onRowClick)="onRowClick($event)">
    
    <dxi-column dataField="id" caption="ID" [width]="80" [allowEditing]="false"></dxi-column>
    <dxi-column dataField="artikl1" caption="Artikl Name" [minWidth]="200"></dxi-column>
    <!-- Add other columns based on your Artikl model -->
    
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<!-- Create Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Dodaj Novi Artikl"
  [(visible)]="isCreatePopupVisible"
  (onHiding)="onCreatePopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="artiklForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="artikl1"
          placeholder="Enter artikl name"
          [isValid]="!artiklForm.get('artikl1')?.errors"
          validationMessage="Artikl name is required">
        </dx-text-box>
        
        <!-- Add other form fields as needed -->
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Kreiraj"
          type="default"
          (onClick)="createArtikl()"
          [disabled]="!artiklForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isCreatePopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

<!-- Edit Popup -->
<dx-popup
  [width]="500"
  [showTitle]="true"
  title="Izmijeni Artikl"
  [(visible)]="isEditPopupVisible"
  (onHiding)="onEditPopupHidden()">
  
  <div *dxTemplate="let data of 'content'">
    <form [formGroup]="artiklForm">
      <div class="form-fields">
        <dx-text-box
          formControlName="artikl1"
          placeholder="Enter artikl name"
          [isValid]="!artiklForm.get('artikl1')?.errors"
          validationMessage="Artikl name is required">
        </dx-text-box>
        
        <!-- Add other form fields as needed -->
      </div>
      
      <div class="popup-buttons">
        <dx-button
          text="Izmijeni"
          type="default"
          (onClick)="updateArtikl()"
          [disabled]="!artiklForm.valid || loading">
        </dx-button>
        
        <dx-button
          text="Otkaži"
          (onClick)="isEditPopupVisible = false">
        </dx-button>
      </div>
    </form>
  </div>
</dx-popup>

  <dx-load-panel
    [position]="loadPanelPosition"
    [visible]="loading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>